import React from 'react';
import "./_footer.scss";
import { useLanguage } from '../LanguageContext'; // ✅ use language context

const textContent = {
  pl: {
    phone: "Kontakt telefoniczny",
    mail: "Kontakt mailowy",
    address: "Adres biura sprzedaży",
    rights: "Wszelkie prawa zastrzeżone"
  },
  en: {
    phone: "Phone contact",
    mail: "Email contact",
    address: "Sales office address",
    rights: "All rights reserved"
  }
};

const Footer = () => {
  const { language } = useLanguage();
  const texts = textContent[language] || textContent.pl;

  return (
    <footer className="footer">
      <div className="footer_container container">
        <div className="footer_info">
          <div className="footer_info_left">
            <div className="footer_item">
              <svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92V19a2 2 0 0 1-2.18 2A19.8 19.8 0 0 1 3 5.18 2 2 0 0 1 5 3h2.09a2 2 0 0 1 2 1.72 13.28 13.28 0 0 0 .57 2.79 2 2 0 0 1-.45 2L8.1 10.11a16 16 0 0 0 6.9 6.9l.58-.58a2 2 0 0 1 2-.45 13.28 13.28 0 0 0 2.79.57 2 2 0 0 1 1.72 2.11z" />
              </svg>
              <span className="footer_info_phone">{texts.phone}: +48 518 330 003, +48 662 234 792</span>
            </div>
            <div className="footer_item">
              <svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16v16H4z" />
                <path d="M22 6l-10 7L2 6" />
              </svg>
              <span className="footer_info_mail">{texts.mail}: polskie.domy.development@outlook.com</span>
            </div>
            <div className="footer_item">
              <svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
                <circle cx="12" cy="9" r="2.5" />
              </svg>
              <span className="footer_info_address">{texts.address}: Mińsk Mazowiecki, Warszawska 66/7, 05-300</span>
            </div>
          </div>
          <span className="footer_copy"> © 2025 PDD, {texts.rights}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
